import { useCourse } from './CourseContext';

export default function CoursesModeDetailsHeader({ onClose }) {
    const course = useCourse();
    return (
        <div className="mode-details-header">
            <h2>{course.name}</h2>
            <button onClick={onClose}>X</button>
        </div>
    );
}
